<template>
  <div class="questionnaire">
    <!-- 问卷头部 -->
    <div class="page-header">
      <img src="@/assets/images/head.jpg" alt="页头图片" class="header-image">
    </div>
    <div class="header">
      <h1>十二件事测试题</h1>
      <p class="description">本测试包含12个主题模块，每个模块5道选择题，请根据您的真实想法选择最符合的选项。</p>
    </div>

    <!-- 基本信息收集 -->
    <div class="basic-info">
      <h2>基本信息</h2>
      <el-form :model="userInfo" label-width="100px">
        <el-form-item label="姓名">
          <el-input v-model="userInfo.name" placeholder="请输入姓名（选填）"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="userInfo.gender">
            <el-radio label="male">男</el-radio>
            <el-radio label="female">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生年月">
          <el-date-picker
            v-model="userInfo.birthDate"
            type="date"
            placeholder="请选择出生年月"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number v-model="userInfo.age" :min="1" :max="120"></el-input-number>
        </el-form-item>
        <el-form-item label="所在地区">
          <el-input
            v-model="userInfo.region"
            placeholder="请输入所在地区"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input 
            v-model="userInfo.phone"
            placeholder="请输入联系电话"
            maxlength="11"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 问题部分 -->
    <div class="questions">
      <div 
        v-for="(section, sectionIndex) in questionnaire" 
        :key="sectionIndex" 
        class="section"
        :data-section="section.title"
      >
        <div v-for="(question, questionIndex) in section.questions" :key="questionIndex" class="question">
          <h3>第{{ sectionIndex * 5 + questionIndex + 1 }}题：{{ question.title.split('. ')[1] }}</h3>
          <el-radio-group v-model="answers[sectionIndex][questionIndex]">
            <el-radio v-for="(option, optionIndex) in question.options" 
                     :key="optionIndex" 
                     :label="optionIndex">
              {{ option.text }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="submit-section">
      <el-button type="primary" @click="submitQuestionnaire">提交问卷</el-button>
    </div>

    <div class="footer">
      <p>版权为
        <a href="https://www.shenchu2.com" target="_blank">
          佛山市顺德区乐从镇神出兔没广告设计部
        </a>
        所有
      </p>
      <p>
        <a href="https://beian.miit.gov.cn" target="_blank">
          粤ICP备18095156号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Questionnaire',
  data() {
    return {
      userInfo: {
        name: '',
        gender: '',
        age: null,
        birthDate: '',
        region: '',
        phone: ''
      },
      questionnaire: [
        {
          title: '一、原生家庭相关',
          description: '以下是5个与原生家庭有关的心理学选择题',
          questions: [
            {
              title: '1. 当你面临压力时，你通常会：',
              options: [
                { text: '冷静分析，积极寻找解决办法，相信自己能够应对', score: 2 },
                { text: '有些焦虑，但会尝试自己处理，偶尔也会向他人求助', score: 1 },
                { text: '感到非常焦虑和无助，经常陷入自我怀疑，难以采取行动', score: 0 },
                { text: '立刻崩溃，完全依赖他人来解决问题，对自己的能力完全丧失信心，长期处于消极状态', score: 0 }
              ]
            },
            {
              title: '2. 在亲密关系中，你：',
              options: [
                { text: '能够轻松地表达自己的情感和需求，也尊重对方的感受，相处和谐', score: 2 },
                { text: '基本能表达自己，但有时会担心对方不高兴，关系还算稳定', score: 1 },
                { text: '很难表达自己的内心想法，害怕被拒绝，容易在关系中受伤', score: 0 },
                { text: '过度依赖对方，总是担心对方会离开，经常因为小事而争吵', score: 0 }
              ]
            },
            {
              title: '3. 对于自己的未来规划，你：',
              options: [
                { text: '有明确的目标和计划，并积极朝着目标努力，不受他人干扰', score: 2 },
                { text: '有一些大致的想法，但也会参考他人的意见，偶尔会犹豫', score: 1 },
                { text: '比较迷茫，不知道自己想要什么，经常随波逐流', score: 0 },
                { text: '完全按照父母或他人的期望来规划，没有自己的主见', score: 0 }
              ]
            },
            {
              title: '4. 当你取得成功时，你会：',
              options: [
                { text: '认为是自己努力的结果，同时也感谢身边人的支持，内心充满成就感', score: 2 },
                { text: '觉得自己运气好，也会想到家人的鼓励，但不会太在意', score: 1 },
                { text: '不敢相信是自己做到的，怀疑自己只是运气好，没有真正的能力', score: 0 },
                { text: '觉得这是为了满足父母或他人的期望，自己并没有多开心', score: 0 }
              ]
            },
            {
              title: '5. 在与朋友的交往中，你：',
              options: [
                { text: '能够平等地与朋友相处，有自己的原则和底线，也能包容朋友的缺点', score: 2 },
                { text: '比较在意朋友的看法，会尽量迎合朋友，偶尔会牺牲自己的感受', score: 1 },
                { text: '很难融入朋友的圈子，觉得自己与他人格格不入，经常被孤立', score: 0 },
                { text: '过于敏感，容易因为朋友的一些小举动而生气或受伤，朋友关系不稳定', score: 0 }
              ]
            }
          ]
        },
        {
          title: '二、把握机遇相关',
          description: '以下是5个与把握机遇和机会相关的心理学选择题',
          questions: [
            {
              title: '1. 当你在一个陌生的社交场合中，你会：',
              options: [
                { text: '主动与不同的人交流，积极拓展人脉，寻找可能的合作机会或新的发展方向', score: 2 },
                { text: '先观察一下，然后与一两个看起来比较友善的人交流，不太会刻意去寻找机会', score: 1 },
                { text: '感到有些紧张，只和自己熟悉的人待在一起，很少与陌生人互动', score: 0 },
                { text: '非常紧张，尽量避免参与社交活动，只想快点离开这个场合，并且之后很长时间都会回避类似的社交场合', score: 0 }
              ]
            },
            {
              title: '2. 当你看到一个感兴趣但又具有一定挑战性的项目时，你会：',
              options: [
                { text: '立刻开始收集相关信息，评估自己的能力，制定计划并积极争取参与其中', score: 2 },
                { text: '有些心动，但会先看看其他人的反应，再考虑自己是否要参与', score: 1 },
                { text: '觉得自己可能做不好，犹豫再三后还是放弃参与的想法', score: 0 },
                { text: '直接认为自己不行，连进一步了解的勇气都没有，直接放弃', score: 0 }
              ]
            },
            {
              title: '3. 假如你在工作中遇到了一个难题，同时有一个新的培训机会可以提升解决该难题的能力，你会：',
              options: [
                { text: '毫不犹豫地报名参加培训，利用业余时间学习，努力提升自己解决问题的能力，以更好地把握后续可能出现的类似机遇', score: 2 },
                { text: '考虑一下自己的工作安排和时间，若不太冲突就参加培训，但不会投入太多额外的精力', score: 1 },
                { text: '觉得参加培训可能会耽误工作，不太愿意去，继续自己摸索解决难题的方法', score: 0 },
                { text: '担心培训没有效果，或者觉得自己不需要培训也能解决问题，拒绝参加培训', score: 0 }
              ]
            },
            {
              title: '4. 当你在生活中面临一个重要的选择，比如换工作、搬家等，你会：',
              options: [
                { text: '全面分析各种选择的利弊，结合自己的长远目标和兴趣爱好，果断做出决定，并为自己的决定负责', score: 2 },
                { text: '会参考家人和朋友的意见，综合考虑后做出决定，但有时会因为他人的看法而犹豫不决', score: 1 },
                { text: '很难做出决定，害怕选错，在不同的选择之间徘徊很久，导致错过最佳时机', score: 0 },
                { text: '完全依赖他人帮自己做决定，自己没有明确的想法和判断', score: 0 }
              ]
            },
            {
              title: '5. 如果你所在的行业出现了一些新的趋势和变化，你会：',
              options: [
                { text: '积极关注这些变化，主动学习新的知识和技能，调整自己的工作方式和策略，以适应新的机遇和挑战', score: 2 },
                { text: '注意到了这些变化，但觉得自己目前的工作方式还能应付，不太愿意花时间去改变', score: 1 },
                { text: '对这些变化不太在意，觉得与自己关系不大，继续按照原来的方式工作', score: 0 },
                { text: '害怕这些变化会给自己带来麻烦，选择逃避，不愿意去了解和面对', score: 0 }
              ]
            }
          ]
        },
        {
          title: '三、环境适应相关',
          description: '以下是5个与原生环境、工作环境、学习环境相关的心理学选择题',
          questions: [
            {
              title: '1. 当你进入一个新的环境（如搬家、换工作、换学校）时，你会首先关注：',
              options: [
                { text: '环境中的人，主动与他们交流，了解环境中的规则和文化等信息', score: 2 },
                { text: '先观察环境的布局和设施，熟悉基本的生活、工作或学习区域', score: 1 },
                { text: '感到有些不安，等待别人来介绍或引导自己去了解环境', score: 0 },
                { text: '非常焦虑，对新环境充满恐惧，尽量避免去接触和了解新事物', score: 0 }
              ]
            },
            {
              title: '2. 在遇到困难或压力时，你通常会从哪里获得支持和力量：',
              options: [
                { text: '家人、朋友和同事等社交圈子，他们能给予情感支持和实际帮助', score: 2 },
                { text: '主要靠自己，偶尔也会向关系较好的人倾诉一下', score: 1 },
                { text: '感觉没有人可以依靠，只能自己默默承受', score: 0 },
                { text: '不知道该找谁，觉得即使找了别人也不会真正理解和帮助自己', score: 0 }
              ]
            },
            {
              title: '3. 对于团队合作，你的看法是：',
              options: [
                { text: '非常喜欢团队合作，能充分发挥自己的优势，也善于与他人协作，共同实现目标', score: 2 },
                { text: '可以接受团队合作，但更倾向于独立完成任务，觉得团队合作有时会效率低下', score: 1 },
                { text: '不太喜欢团队合作，觉得自己的想法经常被忽视，很难融入团队', score: 0 },
                { text: '极度排斥团队合作，认为团队成员会拖累自己，更喜欢独自工作', score: 0 }
              ]
            },
            {
              title: '4. 在学习或工作中，当你发现自己的观点与大多数人不同时，你会：',
              options: [
                { text: '勇敢地表达自己的观点，并与他人进行理性的讨论和交流，以寻求更好的解决方案', score: 2 },
                { text: '会说出自己的想法，但如果遭到反对，就会妥协放弃', score: 1 },
                { text: '担心被别人嘲笑或否定，不敢说出自己的真实想法，选择随声附和', score: 0 },
                { text: '直接否定自己的观点，认为大多数人一定是对的，自己肯定是错的', score: 0 }
              ]
            },
            {
              title: '5. 当你回忆起童年的原生家庭环境时，你首先想到的是：',
              options: [
                { text: '温暖、和谐的家庭氛围，父母的关爱和支持，以及与家人一起度过的快乐时光', score: 2 },
                { text: '家庭生活比较平淡，没有什么特别的事情，父母对自己的要求也不高', score: 1 },
                { text: '家庭中经常充满矛盾和争吵，自己总是感到不安和恐惧', score: 0 },
                { text: '感觉自己在原生家庭中被忽视或冷落，没有得到应有的关爱和重视', score: 0 }
              ]
            }
          ]
        },
        {
          title: '四、行善积德相关',
          description: '以下是5个与行善积德相关的心理学选择题',
          questions: [
            {
              title: '1. 当你看到街边有艺人在表演，你会：',
              options: [
                { text: '主动投钱支持，不论多少，并且真诚地给予鼓励和赞美', score: 2 },
                { text: '看表演很精彩的话，会考虑投一些钱表示支持', score: 1 },
                { text: '只在一旁观看，不会有任何表示，除非别人都投钱了，自己可能会跟着投一点', score: 0 },
                { text: '觉得他们是在赚钱，与自己无关，甚至可能会在心里嘲笑他们', score: 0 }
              ]
            },
            {
              title: '2. 假如你在社交媒体上看到一个公益众筹项目，你的第一反应是：',
              options: [
                { text: '仔细了解项目详情，根据自己的能力决定是否捐款，并可能会帮忙转发扩散', score: 2 },
                { text: '看一下项目，如果是自己感兴趣的领域就考虑捐款，但不会主动去转发', score: 1 },
                { text: '觉得这种众筹可能有假，不太相信，不会捐款也不会关注', score: 0 },
                { text: '认为这些都是骗人的，还会在评论区发表负面言论', score: 0 }
              ]
            },
            {
              title: '3. 在公交车上，遇到一位老人上车，你会：',
              options: [
                { text: '立刻主动起身让座，并且扶老人坐下', score: 2 },
                { text: '观察周围其他人的反应，如果没人让座，自己再考虑让座', score: 1 },
                { text: '假装没看见，或者将头转向窗外，希望别人让座', score: 0 },
                { text: '心里觉得老人站着也没关系，反正自己也很累，不会让座', score: 0 }
              ]
            },
            {
              title: '4. 当你得知朋友遇到困难需要帮助时，你会：',
              options: [
                { text: '主动询问朋友需要什么帮助，尽自己最大的努力去帮忙解决问题，不图回报', score: 2 },
                { text: '先表示同情，然后看自己的时间和精力是否允许，再决定能帮多少忙', score: 1 },
                { text: '只是口头安慰一下朋友，不会采取实际行动帮忙', score: 0 },
                { text: '担心朋友的困难会给自己带来麻烦，尽量避免和朋友接触', score: 0 }
              ]
            },
            {
              title: '5. 你所在的社区组织志愿者活动，你通常会：',
              options: [
                { text: '积极报名参加，并且每次都认真投入，尽力为社区和他人做贡献', score: 2 },
                { text: '偶尔参加一次，如果活动时间和自己的安排不冲突的话', score: 1 },
                { text: '找各种理由推脱，不愿意参加志愿者活动', score: 0 },
                { text: '不仅自己不参加，还会对参加活动的人冷嘲热讽', score: 0 }
              ]
            }
          ]
        },
        {
          title: '五、学习和读书关系相关',
          description: '以下是5个与学习和读书关系相关的心理学选择题',
          questions: [
            {
              title: '1. 当你在阅读一本专业书籍时，遇到一个很难理解的概念，你会：',
              options: [
                { text: '查阅相关资料，尝试从不同角度去理解这个概念，还会向他人请教，直到完全掌握', score: 2 },
                { text: '反复阅读相关内容，努力去理解，如果实在不懂就先跳过，继续阅读后面的内容', score: 1 },
                { text: '觉得很沮丧，直接放弃阅读这本书，认为自己不适合学习这个领域的知识', score: 0 },
                { text: '抱怨书籍编写得不好，把书扔到一边，不再继续阅读', score: 0 }
              ]
            },
            {
              title: '2. 假设你有一个月的假期，你会如何安排你的学习和阅读时间：',
              options: [
                { text: '制定详细的学习和阅读计划，每天安排固定的时间用于阅读不同类型的书籍，包括专业书籍、文学作品等，并会写读书笔记或心得', score: 2 },
                { text: '有大致的想法，会读一些自己感兴趣的书，但不会严格按照计划执行，比较随意', score: 1 },
                { text: '很少主动去阅读和学习，假期主要以休息和娱乐为主，偶尔可能会翻几页书', score: 0 },
                { text: '完全不会考虑学习和阅读，觉得假期就是用来放松的，与学习无关', score: 0 }
              ]
            },
            {
              title: '3. 在学习新知识时，你更倾向于：',
              options: [
                { text: '将新知识与已有的知识体系建立联系，思考它在实际生活中的应用，并尝试用不同的方法去实践和验证', score: 2 },
                { text: '先记住新知识的要点，然后通过做练习题来加深理解和记忆', score: 1 },
                { text: '死记硬背，不考虑知识的内在联系和实际应用，只要能应付考试就行', score: 0 },
                { text: '对新知识缺乏兴趣，觉得学习是一件很痛苦的事情，能逃避就逃避', score: 0 }
              ]
            },
            {
              title: '4. 当你读完一本好书后，你会：',
              options: [
                { text: '与朋友、同学或家人分享书中的内容和自己的感悟，还可能会参加相关的读书讨论活动', score: 2 },
                { text: '在自己的社交媒体上简单推荐一下这本书，但不会深入讨论', score: 1 },
                { text: '读完就结束了，不会有任何后续的行为，也不会和别人交流这本书的内容', score: 0 },
                { text: '觉得读书只是为了打发时间，读完后很快就忘记书中的内容了', score: 0 }
              ]
            },
            {
              title: '5. 如果让你选择一个学习或阅读的环境，你会选择：',
              options: [
                { text: '安静、舒适、有良好照明和充足空间的地方，比如图书馆、书房等，并且会尽量避免干扰', score: 2 },
                { text: '只要不太吵闹就行，比如自己的房间，即使有一些干扰也能勉强学习和阅读', score: 1 },
                { text: '对环境没有什么要求，在哪里都可以学习和阅读，即使周围很嘈杂也无所谓', score: 0 },
                { text: '喜欢在很热闹、有很多人的地方学习和阅读，觉得这样才有氛围，比如商场、咖啡厅等', score: 0 }
              ]
            }
          ]
        },
        {
          title: '六、自身价值相关',
          description: '以下是5个与自身价值相关的心理学选择题',
          questions: [
            {
              title: '1. 当你面临一个新的工作任务，这个任务有一定难度，但完成后可能会带来很大的收获，你会：',
              options: [
                { text: '积极主动地接受任务，把它视为提升自己能力和展现价值的机会，认真规划并努力去完成', score: 2 },
                { text: '有些犹豫，但在他人的鼓励下可能会尝试去做，尽力而为但不会给自己太大压力', score: 1 },
                { text: '觉得自己可能做不好，害怕失败，找借口推脱这个任务', score: 0 },
                { text: '直接拒绝，认为自己没有能力完成，也不相信完成后会有什么收获', score: 0 }
              ]
            },
            {
              title: '2. 在社交场合中，当有人提出一个与你不同的观点时，你会：',
              options: [
                { text: '认真倾听对方的观点，尊重差异，并且能够从对方的角度思考问题，尝试从中学习，同时也清晰地表达自己的看法，进行友好的交流', score: 2 },
                { text: '听一下对方的观点，但不会太在意，坚持自己的想法，不过也不会与对方发生冲突', score: 1 },
                { text: '立刻反驳对方，觉得自己的观点才是正确的，不允许别人质疑', score: 0 },
                { text: '表面上不说话，但心里很生气，觉得对方是在故意针对自己，之后可能会在背后说对方的坏话', score: 0 }
              ]
            },
            {
              title: '3. 如果你有一个月的假期，你会选择怎样提升自己：',
              options: [
                { text: '制定详细的自我提升计划，比如学习一门新技能、阅读专业书籍、参加培训课程等，并且会严格按照计划执行', score: 2 },
                { text: '有一些大致的想法，可能会学一点新东西，但不会很严格地要求自己，比较随意地安排时间', score: 1 },
                { text: '假期主要用来休息和娱乐，偶尔会想过要提升自己，但很少付诸行动', score: 0 },
                { text: '完全不会考虑提升自己，觉得假期就是放松的时间，不需要做任何有意义的事情', score: 0 }
              ]
            },
            {
              title: '4. 当你看到身边的人取得成功时，你的第一反应是：',
              options: [
                { text: '为他们感到高兴，并从中受到激励，思考自己可以从他们身上学到什么，努力提升自己，争取也取得成功', score: 2 },
                { text: '觉得他们很厉害，有点羡慕，但不会有太多实际的行动，只是希望自己也能有这样的好运', score: 1 },
                { text: '心里有些不舒服，觉得他们只是运气好，或者怀疑他们是通过不正当手段取得成功的', score: 0 },
                { text: '嫉妒他们，在背后说他们的坏话，试图贬低他们的成就来平衡自己的心态', score: 0 }
              ]
            },
            {
              title: '5. 在选择职业时，你更看重以下哪个因素：',
              options: [
                { text: '职业发展前景和个人成长空间，愿意为了提升自己的能力和价值而努力工作，即使初期薪资不高也没关系', score: 2 },
                { text: '薪资待遇和福利，认为这是对自己价值的直接体现，但也会考虑一些职业发展的因素', score: 1 },
                { text: '工作轻松和稳定，不太在意职业发展和个人成长，只要能按时上下班，没有太大压力就行', score: 0 },
                { text: '只看公司的名气和地位，觉得在大公司工作就有面子，而不考虑自己在这个职业中能否真正实现自身价值', score: 0 }
              ]
            }
          ]
        },
        {
          title: '七、佛法世界观相关',
          description: '以下是5个基于佛法世界观中认识实相的心理学选择题',
          questions: [
            {
              title: '1. 当你看到他人在社交媒体上炫耀自己的财富和成就时，你的内心反应是：',
              options: [
                { text: '明白这些外在的表现只是短暂的现象，是虚幻的相，不会因此产生羡慕或嫉妒，而是专注于自身内在的成长和修行，思考如何提升自己的精神境界', score: 2 },
                { text: '有点羡慕，但也知道这些不一定能带来真正的幸福，会提醒自己不要过于在意，要关注自己生活中的其他方面', score: 1 },
                { text: '感到很羡慕，觉得自己不如别人，开始抱怨自己的生活不如意，对自己的现状不满', score: 0 },
                { text: '不仅羡慕，还产生了嫉妒心理，在心里贬低对方，认为对方是在故意炫耀，同时对自己的生活感到极度沮丧和失落', score: 0 }
              ]
            },
            {
              title: '2. 你在工作中遇到了一个很大的困难，可能会影响到你的职业发展，你会：',
              options: [
                { text: '把这个困难看作是一种因缘和合的现象，是无常的表现，不会过分焦虑和执着于结果。而是冷静分析问题，尽自己的努力去解决，同时明白无论结果如何，都是一种经历和成长', score: 2 },
                { text: '感到有些压力，但会努力调整心态，积极寻找解决办法，告诉自己这只是暂时的，只要克服了就会有进步', score: 1 },
                { text: '陷入焦虑和恐慌中，觉得自己的职业生涯要毁了，对未来失去信心，无法集中精力去解决问题', score: 0 },
                { text: '完全被困难击垮，产生了逃避的想法，甚至想要放弃工作，认为自己没有能力应对，对自己和未来都感到绝望', score: 0 }
              ]
            },
            {
              title: '3. 当你与一位朋友发生意见分歧，对方坚持自己的观点，不愿妥协时，你会：',
              options: [
                { text: '认识到每个人的观点都是基于自己的因缘和认知产生的，没有绝对的对错，不会强行要求对方改变。而是尝试从对方的角度去理解，以平和的心态继续沟通，寻求共识或求同存异', score: 2 },
                { text: '有点不高兴，但还是会尊重对方的意见，不会过于纠结，会暂时放下分歧，等双方都冷静后再讨论', score: 1 },
                { text: '觉得对方不可理喻，一定要说服对方接受自己的观点，开始与对方争论，情绪也变得激动起来', score: 0 },
                { text: '非常生气，认为朋友不应该这样对待自己，决定不再与对方交流，甚至开始考虑是否要结束这段友谊', score: 0 }
              ]
            },
            {
              title: '4. 你计划了一次旅行，但因为突发情况不得不取消，你的反应是：',
              options: [
                { text: '理解这是因缘的变化，旅行的计划也是一种相，不必执着。会重新调整心态，把这次的空闲时间用于其他有意义的事情上，比如读书、修行或陪伴家人', score: 2 },
                { text: '有些失落，但也能接受，会想办法在附近找一些其他活动来做，让自己的假期依然充实', score: 1 },
                { text: '感到非常失望，觉得自己的期待落空了，一整天都情绪低落，什么事情都不想做', score: 0 },
                { text: '陷入愤怒和抱怨中，责怪各种原因导致旅行取消，甚至对身边的人发脾气，无法释怀这件事情', score: 0 }
              ]
            },
            {
              title: '5. 你在生活中追求某一目标，经过长时间努力却始终未能实现，你会：',
              options: [
                { text: '明白目标的追求也是一种虚妄的执着，世间万物皆有其因缘和规律。不会因此而沮丧，而是反思自己的追求是否符合真正的实相，调整方向，从过程中寻找收获和成长', score: 2 },
                { text: '有些气馁，但不会放弃，会重新评估自己的方法和计划，继续努力，相信只要坚持就有可能实现目标', score: 1 },
                { text: '感到非常挫败，开始怀疑自己的能力，对未来的目标追求也失去了信心，变得消极怠工', score: 0 },
                { text: '陷入深深的痛苦和自我否定中，认为自己是个失败者，从此一蹶不振，不再有追求目标的动力和勇气', score: 0 }
              ]
            }
          ]
        },
        {
          title: '八、敬畏之心相关',
          description: '以下是5个与敬畏之心相关的心理学选择题',
          questions: [
            {
              title: '1. 当你面对大自然的壮丽景观（如高山、大海）时，你的内心感受是：',
              options: [
                { text: '感受到自然的伟大和神秘，对生命和宇宙充满敬畏，会思考人与自然的关系，珍惜当下的体验', score: 2 },
                { text: '觉得景色很美，会拍照留念，但不会有太多深层的思考', score: 1 },
                { text: '只是走马观花，觉得不过如此，很快就失去了兴趣', score: 0 },
                { text: '完全无感，甚至觉得浪费时间，更愿意待在室内玩手机', score: 0 }
              ]
            },
            {
              title: '2. 当你听到或看到一些重大灾难事件的报道时，你会：',
              options: [
                { text: '深感生命的脆弱和无常，对逝者表示哀悼，同时反思如何在日常生活中更好地珍惜生命、关爱他人', score: 2 },
                { text: '感到难过和同情，可能会捐款或转发相关信息，但很快就会回到日常生活中', score: 1 },
                { text: '觉得这些事情离自己很远，不会太在意，认为这是他们的命运', score: 0 },
                { text: '对这类新闻麻木不仁，甚至会对受害者的遭遇说三道四', score: 0 }
              ]
            },
            {
              title: '3. 面对长辈或师长的教导时，你的态度是：',
              options: [
                { text: '怀着恭敬和感恩的心认真聆听，理解他们的用心，并努力将教导付诸实践，同时也会理性思考和消化', score: 2 },
                { text: '基本上会听从，但有时会觉得他们的想法过时，选择性接受', score: 1 },
                { text: '觉得他们太啰嗦，常常敷衍应付，很少真正放在心上', score: 0 },
                { text: '完全不接受他们的教导，认为自己更懂，经常顶撞或嘲讽他们的观点', score: 0 }
              ]
            },
            {
              title: '4. 当你接触到古代文化遗产（如古建筑、文物等）时，你会：',
              options: [
                { text: '对先人的智慧和创造力充满敬意，会主动了解其历史和文化内涵，思考如何传承和保护这些珍贵的遗产', score: 2 },
                { text: '觉得很有意思，会拍照记录，也会听导游讲解，但不会深入研究', score: 1 },
                { text: '觉得这些东西又旧又破，不明白为什么要保护，认为应该都推倒重建', score: 0 },
                { text: '完全不关心这些，甚至会做一些破坏性的行为，如刻字、触摸文物等', score: 0 }
              ]
            },
            {
              title: '5. 在面对生命中的重大抉择时，你会：',
              options: [
                { text: '怀着敬畏之心慎重考虑，权衡利弊，同时也会寻求智者的建议，深思熟虑后再做决定', score: 2 },
                { text: '会考虑一段时间，参考他人意见，但最终还是按照自己的想法来决定', score: 1 },
                { text: '凭直觉随便选择，不觉得决定有什么特别重要的', score: 0 },
                { text: '完全不在乎后果，想到什么就做什么，经常做出让自己后悔的决定', score: 0 }
              ]
            }
          ]
        },
        {
          title: '九、健康生活相关',
          description: '以下是5个与健康生活相关的心理学选择题',
          questions: [
            {
              title: '1. 对于日常饮食，你的态度是：',
              options: [
                { text: '注重营养均衡，合理搭配各类食物，规律进餐，同时也会适当控制饮食量，保持健康的饮食习惯', score: 2 },
                { text: '基本能保持正常饮食，但有时会因为工作忙或其他原因而吃得不规律，偶尔也会放纵一下', score: 1 },
                { text: '经常不按时吃饭，爱吃垃圾食品，对饮食健康不太在意，想吃什么就吃什么', score: 0 },
                { text: '饮食非常不规律，要么暴饮暴食，要么节食减肥，完全不考虑营养需求，长期以来已经形成了不健康的饮食习惯', score: 0 }
              ]
            },
            {
              title: '2. 关于运动锻炼，你会：',
              options: [
                { text: '保持规律的运动习惯，每周至少运动3-4次，并且会根据自己的身体状况选择适合的运动方式', score: 2 },
                { text: '偶尔运动一下，主要是心情好或有朋友相约时才会去运动', score: 1 },
                { text: '很少运动，觉得太累了，除非必要情况下才会活动一下', score: 0 },
                { text: '完全不运动，认为运动没有意义，宁愿把时间用在其他事情上', score: 0 }
              ]
            },
            {
              title: '3. 在作息时间方面，你通常：',
              options: [
                { text: '有规律的作息时间，每天保证充足的睡眠，不熬夜，早起后感觉精力充沛', score: 2 },
                { text: '尽量保持正常作息，但有时会因为工作或娱乐而晚睡，第二天会感觉有点疲惫', score: 1 },
                { text: '经常熬夜，睡眠时间不固定，导致白天精神不好，但已经习惯了这种状态', score: 0 },
                { text: '完全没有固定的作息规律，经常通宵玩手机或打游戏，严重影响了身体健康', score: 0 }
              ]
            },
            {
              title: '4. 当你感觉身体不适时，你会：',
              options: [
                { text: '及时就医检查，按医嘱服药和休息，同时也会注意调整生活习惯，预防疾病复发', score: 2 },
                { text: '先自己观察几天，如果症状持续才会去看医生，会听从医生的建议但执行不够严格', score: 1 },
                { text: '一般不去医院，自己买点药吃，觉得小病没什么大不了的', score: 0 },
                { text: '完全不在意身体的警告信号，继续维持不健康的生活方式，直到病情严重才被迫就医', score: 0 }
              ]
            },
            {
              title: '5. 在压力管理方面，你会：',
              options: [
                { text: '学会识别压力信号，主动采取健康的方式减压，如运动、冥想、听音乐等，保持身心平衡', score: 2 },
                { text: '感觉压力大时会想办法放松一下，但方式可能不太健康，比如吃零食、购物等', score: 1 },
                { text: '不太会管理压力，经常感到焦虑和紧张，但不知道该如何缓解', score: 0 },
                { text: '用不健康的方式发泄压力，如酗酒、暴饮暴食，甚至会把负面情绪发泄到他人身上', score: 0 }
              ]
            }
          ]
        },
        {
          title: '十、人际关系相关',
          description: '以下是5个与人际关系相关的心理学选择题',
          questions: [
            {
              title: '1. 在与他人交往时，你通常会：',
              options: [
                { text: '真诚对待每个人，尊重他人的个性差异，善于倾听和表达，能够建立和维护良好的人际关系', score: 2 },
                { text: '对熟悉的人比较热情，对陌生人保持礼貌但有所保留，基本能维持正常的社交关系', score: 1 },
                { text: '不太善于与人交往，经常感到尴尬和不自在，很难与他人建立深入的关系', score: 0 },
                { text: '对人际交往充满戒备和抗拒，认为与人交往很麻烦，宁愿独处', score: 0 }
              ]
            },
            {
              title: '2. 当你与他人发生矛盾时，你会：',
              options: [
                { text: '冷静分析问题的原因，主动沟通和化解矛盾，寻求双方都能接受的解决方案', score: 2 },
                { text: '尽量避免正面冲突，等待时机再慢慢解决，或者请他人帮忙调解', score: 1 },
                { text: '把问题压在心里，表面上装作没事，但会在心中积累怨气', score: 0 },
                { text: '立即与对方断绝来往，认为关系破裂就无法挽回，不愿意尝试修复', score: 0 }
              ]
            },
            {
              title: '3. 在团队合作中，你倾向于：',
              options: [
                { text: '积极参与团队讨论，贡献自己的想法，同时也尊重和支持他人的观点，共同完成目标', score: 2 },
                { text: '完成分配给自己的任务，与团队成员保持基本的沟通，但不会主动承担更多责任', score: 1 },
                { text: '被动地等待他人安排，很少发表意见，害怕承担责任和犯错', score: 0 },
                { text: '独断专行，不愿意与他人合作，认为团队合作效率低下', score: 0 }
              ]
            },
            {
              title: '4. 当朋友遇到困难向你倾诉时，你会：',
              options: [
                { text: '认真倾听朋友的烦恼，表达理解和支持，并尽可能提供实际的帮助和建议', score: 2 },
                { text: '听朋友说完，给予一些安慰，但不会过多介入对方的问题', score: 1 },
                { text: '觉得对方的问题很麻烦，敷衍了事，希望快点结束谈话', score: 0 },
                { text: '对朋友的困难表现出不耐烦，甚至会指责对方能力不足或判断失误', score: 0 }
              ]
            },
            {
              title: '5. 在维护长期友谊方面，你会：',
              options: [
                { text: '经常与朋友保持联系，关心对方的生活，在重要时刻给予支持，珍惜和维护这份友谊', score: 2 },
                { text: '偶尔联系朋友，在节假日或特殊场合会问候对方，基本能维持友谊', score: 1 },
                { text: '很少主动联系朋友，觉得友谊会自然而然地维持，不需要特别去经营', score: 0 },
                { text: '对友谊持无所谓的态度，认为朋友来来去去很正常，不值得投入时间和精力去维护', score: 0 }
              ]
            }
          ]
        },
        {
          title: '十一、择业创业相关',
          description: '以下是5个与择业、创业、选择工作赛道相关的心理学选择题',
          questions: [
            {
              title: '1. 当你面对多个工作机会时，你会更关注：',
              options: [
                { text: '工作内容是否能让自己不断成长和进步，是否有机会发挥自己的优势和潜力，同时也会考虑公司的文化和团队氛围是否与自己相符', score: 2 },
                { text: '薪资待遇和福利，以及工作的稳定性，觉得这些是保障生活的重要因素，其他方面可以在工作后再慢慢适应', score: 1 },
                { text: '公司的地理位置和工作时间，希望工作地点离自己住的地方近一些，工作时间不要太长，这样可以有更多的个人时间', score: 0 },
                { text: '只看公司的名气和规模，认为大公司或知名公司一定更好，而不考虑具体的工作岗位和自身的兴趣能力是否匹配', score: 0 }
              ]
            },
            {
              title: '2. 在创业想法产生后，你首先会做的是：',
              options: [
                { text: '进行详细的市场调研，了解目标市场的需求、竞争状况以及发展趋势，同时评估自己的资源和能力，制定初步的商业计划和策略', score: 2 },
                { text: '先和身边的朋友、家人讨论，听取他们的意见和建议，然后开始寻找合作伙伴或投资，觉得人多力量大，大家一起想办法更容易成功', score: 1 },
                { text: '马上行动，租场地、招员工、购买设备等，先把摊子铺开，边做边看，遇到问题再解决，没有一个明确的规划和方向', score: 0 },
                { text: '犹豫不决，担心风险太大，害怕失败，虽然有想法但一直不敢迈出第一步，反复纠结在各种可能性和困难中', score: 0 }
              ]
            },
            {
              title: '3. 如果你在现有的工作中遇到了瓶颈，你会：',
              options: [
                { text: '主动寻求新的挑战和机会，比如申请内部转岗、参与公司的新项目或者学习新的技能，提升自己的竞争力，为未来的职业发展打下基础', score: 2 },
                { text: '向领导反映自己的情况，希望领导能够给予一些指导或帮助，调整工作内容或分配一些更有挑战性的任务，但自己不会主动去尝试新的事物', score: 1 },
                { text: '继续维持现状，觉得反正大家都差不多，过一天算一天，不愿意花费精力去改变，对工作的热情逐渐降低', score: 0 },
                { text: '频繁抱怨工作的不如意，但又不采取任何实际行动，把责任都归咎于公司或同事，认为是外部环境限制了自己的发展', score: 0 }
              ]
            },
            {
              title: '4. 对于选择工作赛道，你的看法是：',
              options: [
                { text: '认为应该结合自己的兴趣、能力和市场需求来选择，会对不同的行业和职业进行深入了解和分析，找到一个既能让自己有热情投入，又有发展前景的赛道', score: 2 },
                { text: '觉得跟着热门趋势走就没错，哪个行业火就往哪个行业去，不考虑自己是否真的适合，相信只要在热门行业中就能获得成功', score: 1 },
                { text: '完全听从家人、朋友或老师的建议，他们觉得哪个工作好就选择哪个，自己没有明确的主见和判断', score: 0 },
                { text: '随机选择，没有任何规划和考虑，觉得反正工作都差不多，先找一个干着再说，不行再换', score: 0 }
              ]
            },
            {
              title: '5. 在面试时，你更注重展示：',
              options: [
                { text: '自己的专业技能、工作经验以及解决问题的能力，同时也会强调自己的团队合作精神、学习能力和适应能力，全方位地展示自己与岗位的匹配度', score: 2 },
                { text: '主要展示自己的工作经验和业绩，觉得这些是最能证明自己能力的方面，对于其他方面的能力只是简单提及', score: 1 },
                { text: '过于紧张，只能简单地回答面试官的问题，无法充分展示自己的优势和特长，甚至会因为紧张而说错话或表现出不自信', score: 0 },
                { text: '夸夸其谈，过分强调自己的优点和成就，甚至夸大其词，而对自己的不足和缺点避而不谈，给面试官留下不踏实、不诚信的印象', score: 0 }
              ]
            }
          ]
        },
        {
          title: '十二、择偶婚姻相关',
          description: '以下是5个与择偶、婚姻幸福、两性关系相关的心理学选择题',
          questions: [
            {
              title: '1. 当你想象未来的伴侣与你一起度过周末时，你首先想到的是：',
              options: [
                { text: '一起做双方都喜欢的活动，比如看电影、户外运动，然后交流彼此的感受和想法', score: 2 },
                { text: '各做各的事，但在同一个空间里，偶尔说几句话', score: 1 },
                { text: '自己独自度过，觉得伴侣在不在身边无所谓', score: 0 },
                { text: '要求伴侣按照自己的喜好安排周末，比如陪自己逛街或打游戏，不考虑对方的意愿', score: 0 }
              ]
            },
            {
              title: '2. 在一段感情中，你认为以下哪种沟通方式最重要：',
              options: [
                { text: '认真倾听对方的想法和感受，同时清晰地表达自己的观点，尊重彼此的差异并共同寻找解决问题的方法', score: 2 },
                { text: '主要是自己表达，希望对方能理解自己，但不太关注对方的回应', score: 1 },
                { text: '很少主动沟通，觉得有问题也会自己默默消化，不希望给对方添麻烦', score: 0 },
                { text: '一旦有不同意见就会争吵，试图通过争论让对方屈服于自己的观点', score: 0 }
              ]
            },
            {
              title: '3. 当你的伴侣在工作中遇到挫折时，你会：',
              options: [
                { text: '先给予情感上的支持和鼓励，让对方知道你会一直陪伴他/她，然后一起分析问题，寻找解决办法', score: 2 },
                { text: '简单安慰几句，然后建议对方不要太在意，继续努力就好', score: 1 },
                { text: '觉得这是对方自己的事情，让他/她自己处理，不主动过问', score: 0 },
                { text: '抱怨对方能力不足，或者拿别人的成功来对比，给对方施加压力', score: 0 }
              ]
            },
            {
              title: '4. 如果你和伴侣计划一起旅行，你会更注重：',
              options: [
                { text: '旅行中的体验和互动，一起探索新的地方，创造美好的回忆，同时也会考虑对方的兴趣爱好来安排行程', score: 2 },
                { text: '旅行的目的地和行程安排，希望一切都井井有条，按照自己的计划进行，但也会适当听取对方的意见', score: 1 },
                { text: '只关注自己在旅行中的感受，比如住宿条件、美食等，不太在意伴侣的需求和想法', score: 0 },
                { text: '对旅行不感兴趣，觉得不如在家休息，只是为了满足伴侣的愿望而勉强参加', score: 0 }
              ]
            },
            {
              title: '5. 在择偶时，对于对方的过去，你会：',
              options: [
                { text: '尊重对方的过去，认为每个人都有自己的经历，更关注彼此的现在和未来，愿意与对方一起创造新的生活', score: 2 },
                { text: '会好奇对方的过去，但不会过度追问，只要对方对自己坦诚就好', score: 1 },
                { text: '经常追问对方的过去，对一些细节耿耿于怀，甚至会因为对方的过去而产生猜忌和不安', score: 0 },
                { text: '完全不能接受对方有任何过去的感情经历或不好的事情，要求对方必须是完美无缺的', score: 0 }
              ]
            }
          ]
        }
      ],
      answers: Array(12).fill().map(() => Array(5).fill(null)),
    }
  },
  methods: {
    validateAnswers() {
      const unansweredQuestions = []
      
      this.answers.forEach((sectionAnswers, sectionIndex) => {
        sectionAnswers.forEach((answer, questionIndex) => {
          if (answer === null) {
            unansweredQuestions.push({
              section: this.questionnaire[sectionIndex].title,
              question: questionIndex + 1
            })
          }
        })
      })
      
      if (unansweredQuestions.length > 0) {
        const message = unansweredQuestions.map(q => 
          `${q.section}的第${q.question}题`
        ).join('、')
        
        this.$message({
          message: `请完成以下题目：${message}`,
          type: 'warning',
          duration: 5000,
          showClose: true
        })
        
        // 滚动到第一个未答题的位置
        const firstUnanswered = unansweredQuestions[0]
        const sectionEl = document.querySelector(
          `[data-section="${firstUnanswered.section}"]`
        )
        if (sectionEl) {
          sectionEl.scrollIntoView({ behavior: 'smooth' })
        }
        
        return false
      }
      
      return true
    },

    validateForm() {
      if (!this.userInfo.phone && this.userInfo.phone.length !== 11) {
        this.$message.warning('请输入正确的手机号码')
        return false
      }
      return true
    },

    submitQuestionnaire() {
      if (!this.validateForm()) return
      if (!this.validateAnswers()) return

      const scores = this.calculateScores()
      
      // 直接跳转到结果页面，不需要调用API
      this.$router.push({
        path: '/result',
        query: { 
          scores: JSON.stringify(scores),
          userInfo: JSON.stringify(this.userInfo)
        }
      })
    },

    calculateScores() {
      // 计算每个模块的得分
      return this.answers.map((section, sectionIndex) => {
        return section.reduce((total, answer, questionIndex) => {
          return total + this.questionnaire[sectionIndex].questions[questionIndex].options[answer].score
        }, 0)
      })
    }
  }
}
</script>

<style scoped>
.questionnaire {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  min-height: 100vh;
}

.page-header {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 20px;
  text-align: center;
}

.header-image {
  width: auto;
  height: auto;
  max-height: 250px;
  max-width: 100%;
  display: block;
  object-fit: contain;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px 0;
  border-bottom: 2px solid #eee;
}

.header h1 {
  font-size: 28px;
  color: #333;
  margin-bottom: 15px;
}

.description {
  color: #666;
  font-size: 16px;
}

.basic-info {
  background: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 40px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.basic-info h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.section {
  margin-bottom: 50px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
}

.section h2 {
  font-size: 22px;
  color: #409EFF;
  margin-bottom: 15px;
}

.section-desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #eee;
}

.question {
  margin-bottom: 30px;
  padding: 20px;
  background: #fafafa;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  position: relative;
  overflow: hidden;
}

.question h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
  background: #f0f7ff;
  padding: 10px 15px;
  border-radius: 4px;
  border-left: 4px solid #409EFF;
  width: 90%;
  margin: 0 auto 12px;
}

/* 问题选项样式 */
.question .el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  width: 90%;
  margin: 0 auto;
}

/* 重置 Element UI 的默认样式 */
/deep/ .el-radio {
  margin: 0;
  width: 90%;
  margin: 0 auto;
  padding: 8px 15px;
  display: flex;
  align-items: flex-start;
  border: 1px solid #eee;
  border-radius: 4px;
  background: #fff;
  justify-content: flex-start;  /* 确保内容左对齐 */
}

/deep/ .el-radio__label {
  padding-left: 8px;
  white-space: normal !important;
  line-height: 1.4;
  color: #666;
  font-size: 14px;
  flex: 1;
  text-align: left;
  padding-right: 10px;
}

.question .el-radio__input {
  margin-right: 8px;
  flex-shrink: 0;
  margin-top: 2px;
  margin-left: 0;  /* 确保单选按钮靠左 */
}

.question .el-radio:hover {
  background: #f5faff;
  border-color: #c6e2ff;
}

.question .el-radio.is-checked {
  background: #f0f9ff;
  border-color: #409EFF;
}

.question .el-radio.is-checked .el-radio__label {
  color: #409EFF;
}

@media screen and (max-width: 768px) {
  .question .el-radio-group,
  .question .el-radio,
  .question h3 {
    width: 90%;
  }
}

.submit-section {
  text-align: center;
  margin: 40px 0;
  padding: 20px 0;
}

.submit-section .el-button {
  padding: 12px 40px;
  font-size: 16px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .questionnaire {
    padding: 15px;
  }

  .header h1 {
    font-size: 24px;
  }

  .section {
    padding: 15px;
  }

  .question {
    padding: 15px;
  }

  /deep/ .el-radio {
    padding: 10px 15px;
    margin-bottom: 10px;
  }

  .basic-info {
    padding: 15px;
  }

  /deep/ .el-form-item {
    padding: 10px 15px;
  }

  /deep/ .el-radio-group {
    flex-direction: column;
    gap: 10px;
  }

  /deep/ .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    margin-bottom: 8px;
  }

  /deep/ .el-input,
  /deep/ .el-date-picker,
  /deep/ .el-cascader {
    width: 100%;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* 选中状态的样式 */
/deep/ .el-radio.is-checked {
  background: #f0f9ff;
  border-color: #409EFF;
}

/deep/ .el-radio.is-checked .el-radio__label {
  color: #409EFF;
}

/* 基础信息表单布局优化 */
.basic-info .el-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 20px;
}

/deep/ .el-form-item {
  margin-bottom: 0;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
}

/deep/ .el-form-item.is-required .el-form-item__label::before {
  color: #ff4949;
}

/deep/ .el-form-item__label {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  padding-bottom: 8px;
}

/deep/ .el-input__inner,
/deep/ .el-date-picker,
/deep/ .el-cascader {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  width: 100%;
}

/deep/ .el-radio-group {
  display: flex;
  gap: 15px;
}

/deep/ .el-radio {
  margin: 0;
  padding: 8px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .basic-info .el-form {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 10px;
  }

  /deep/ .el-form-item {
    padding: 15px;
  }

  /deep/ .el-radio-group {
    flex-direction: column;
    gap: 10px;
  }

  /deep/ .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    margin-bottom: 8px;
  }
}

.footer {
  text-align: center;
  padding: 20px 0;
  margin-top: 40px;
  border-top: 1px solid #eee;
  color: #666;
  font-size: 14px;
}

.footer p {
  margin: 5px 0;
}

.footer a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer a:hover {
  color: #409EFF;
}
</style> 